export const minusIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M20 9H0v2h20z"/></svg>`,
  name: 'minus',
};
